import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  firstName: string
  lastName: string
  firstNameKana: string
  lastNameKana: string
  isLivingAbroad: boolean
  prefectureId: number | null
  userProfileImagePath: string | null
  sexId: string | null
  birthday: string | null
}

export class ChangeBaseInformationWriteRequest extends WriteRequest<void> {
  private readonly endpoint: string =
    "/user_profile/user/edit/base_information/change"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, this.params)
  }
}
